const locations = document.querySelectorAll(".filterBtn");
const members = document.querySelectorAll(".member");
const filter = {"location":0};
locations.forEach(location => {
    location.addEventListener('click', function() {
        if(this.classList.contains("is-active")){
            this.classList.remove("is-active");
            filter.location = 0;
        }else{
            locations.forEach(function (e) {
                e.classList.remove("is-active");
            })
            this.classList.add("is-active");
            filter.location = parseInt(this.dataset.locationId);
        }
        members.forEach(member => {
            member.classList.remove("is-hidden");
            if(filter.location !== 0){
                if(parseInt(member.dataset.locationId) !== filter.location){
                    member.classList.add("is-hidden");
                }
            }else{
                member.classList.remove("is-hidden");
            }
        })
    });
});



